export default class ChangedScoresModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.scores === undefined || content.scores.change === undefined) {
            return;
        }

        const scores = content.scores.change;

        for (let i = 0; i < scores.length; i++) {
            const score = scores[i];

            const scoreKey = this._modelKeyRepository.getScoreKey(score.id);

            scores[i] = Object.assign({
                score1: score.s1,
                score2: score.s2,
                team: score.tm,
                type: score.t,
                isActive: score.ia
            }, scoreKey);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ChangedScoresModifier.js